import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';

import ImageModal from './ImageModal';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

const StyledSlider = styled.div`
  width: 100%;

  .Slider__item {
    cursor: pointer;
  }

  button {
    background: transparent;
    border: none;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .carousel.carousel-slider .control-arrow {
    background: rgba(0, 0, 0, 0.3);
    padding: 15px;

    &:hover {
      background: rgba(0, 0, 0, 0.4);
    }
  }
`;

class ImageSlider extends PureComponent {
  state = { modalImage: null };

  onOpenModal = (_, slide) => {
    this.setState({ modalImage: slide.key });
    return _;
  };

  onCloseModal = () => {
    this.setState({ modalImage: null });
  };

  render() {
    const { prefix = '', images } = this.props;
    const settings = {
      onClickItem: this.onOpenModal,
      showIndicators: false,
      showStatus: false,
      showThumbs: false,
      infiniteLoop: true,
      useKeyboardArrows: true,
      emulateTouch: true,
    };

    return (
      <React.Fragment>
        <StyledSlider>
          <Carousel {...settings}>
            {images.map((image, i) => (
              <div className="Slider__item" key={image}>
                <img src={image} alt={`${prefix}-${i+1}`} />
              </div>
            ))}
          </Carousel>
        </StyledSlider>
        {this.state.modalImage && <ImageModal image={this.state.modalImage} onClose={this.onCloseModal} />}
      </React.Fragment>
    );
  }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/components/ImageSlider.js